// Venue details, ported from the app so both show the same information:
//   PiattoRNMobileApp screens/business/VenueDetailsSection.tsx (groups, labels)
//   screens/business/BusinessScreen.tsx priceRangeText (estimated price)
// Keep labels in step with those files.

const group = (title, chips) => ({ title, chips: chips.filter((c) => c.value != null) });

/** Groups of { label, value:true|false }; null/undefined values and empty groups are dropped. */
export function buildDetailGroups(v) {
  if (!v) return [];
  const parking = v.bizParking || {};
  const pay = v.bizPaymentOptions || {};
  return [
    group("Service Options", [
      { label: "Dine-in", value: v.bizDineIn },
      { label: "Delivery", value: v.bizDelivery },
      { label: "Takeout", value: v.bizTakeout },
      { label: "Curbside pickup", value: v.bizCurbsidePickup },
    ]),
    group("Meals", [
      { label: "Breakfast", value: v.bizServesBreakfast },
      { label: "Brunch", value: v.bizServesBrunch },
      { label: "Lunch", value: v.bizServesLunch },
      { label: "Dinner", value: v.bizServesDinner },
      { label: "Dessert", value: v.bizServesDessert },
      { label: "Vegetarian options", value: v.bizServesVegetarianFood },
    ]),
    group("Drinks", [
      { label: "Coffee", value: v.bizServesCoffee },
      { label: "Beer", value: v.bizServesBeer },
      { label: "Wine", value: v.bizServesWine },
      { label: "Cocktails", value: v.bizServesCocktails },
    ]),
    group("Amenities", [
      { label: "Outdoor seating", value: v.bizOutdoorSeating },
      { label: "Live music", value: v.bizLiveMusic },
      { label: "Children's menu", value: v.bizMenuForChildren },
      { label: "Good for children", value: v.bizGoodForChildren },
      { label: "Good for groups", value: v.bizGoodForGroups },
      { label: "Good for watching sports", value: v.bizGoodForWatchingSports },
      { label: "Dogs allowed", value: v.bizAllowsDogs },
      { label: "Restroom", value: v.bizRestroom },
    ]),
    group("Parking", [
      { label: "Free parking lot", value: parking.freeParkingLot },
      { label: "Paid parking lot", value: parking.paidParkingLot },
      { label: "Free street parking", value: parking.freeStreetParking },
      { label: "Paid street parking", value: parking.paidStreetParking },
      { label: "Valet parking", value: parking.valetParking },
      { label: "Free garage parking", value: parking.freeGarageParking },
      { label: "Paid garage parking", value: parking.paidGarageParking },
    ]),
    group("Payment", [
      { label: "Credit cards", value: pay.acceptsCreditCards },
      { label: "Debit cards", value: pay.acceptsDebitCards },
      { label: "Cash only", value: pay.acceptsCashOnly },
      { label: "Contactless (NFC)", value: pay.acceptsNfc },
    ]),
  ].filter((g) => g.chips.length > 0);
}

/** App's "Est price: $20 – $40" from bizPriceRange (Google Places), else null. */
export function estimatedPriceText(v) {
  const pr = v?.bizPriceRange;
  if (!pr?.startPrice?.units || !pr?.endPrice?.units) return null;
  const code = pr.startPrice.currencyCode;
  const symbol = !code || code === "AUD" ? "$" : `${code} `;
  return `${symbol}${pr.startPrice.units} – ${symbol}${pr.endPrice.units}`;
}

export const googleReviews = (v) => (Array.isArray(v?.googleReviews) ? v.googleReviews.filter(Boolean) : []);
